import { catchError, map, switchMap } from 'rxjs/operators';
import { OrderBuilderState } from './../../../../../reducers/index';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { IEffect } from '../../../../../../shared/modules/dynamic-effects/effect.interface';
import {
  ProductActions,
  ProductLoadCompleteAction,
  ProductLoadFailAction,
  OP_PRODUCT_EXPERIENCE_LOAD,
} from '../../../actions/products-actions/products.actions';
import {
  ProductsOpenPlatformService,
  ProductsResponseOP,
  ProductOPReq,
  ProductService,
  TopProductsReq,
  TopProductsResp,
} from '@cemex-core/cmx-api';

/**
 * An effect which monitors the actions$ Observable for (product jobsite experience) LOAD operations
 * and then evaluate what api is next to call depending on experience
 */
@Injectable()
export class ProductExperienceLoadEffects implements IEffect {
  productExperienceLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OP_PRODUCT_EXPERIENCE_LOAD),
      switchMap((action: ProductActions) => {
        const onlineRequest: ProductOPReq = {
          jobsiteId: action.payload.jobsiteId,
          productTypeId: action.payload.productTypeId,
        };
        const request: TopProductsReq = {
          shipmentLocationId: action.payload.shipmentLocationId,
          shippingConditionId: action.payload.shippingConditionId,
          productLineId: action.payload.productTypeId,
          salesDocumentTypeId: action.payload.salesDocumentTypeId,
        };
        const isOnline = action.payload.isOnline;
        if (isOnline) {
          return this.productsApi.getProducts(onlineRequest).pipe(
            map((response: ProductsResponseOP) => {
              this.store.dispatch(new ProductLoadCompleteAction(response));
              return new ProductLoadCompleteAction(response);
            }),
            catchError((error) => of(new ProductLoadFailAction(error))),
          );
        }
        return this.productService.getTopProducts(request).pipe(
          map((response: TopProductsResp) => {
            const productsResponseOP: ProductsResponseOP = {
              products: response.products.map((x) => {
                return {
                  productId: x.product.productId,
                  productCode: x.commercialCode,
                  productDesc: x.commercialDesc,
                  unit: {
                    unitId: x.unitOfMeasure.unitId,
                    unitCode: '',
                  },
                };
              }),
            };
            return productsResponseOP;
          }),
          map((response: ProductsResponseOP) => {
            this.store.dispatch(new ProductLoadCompleteAction(response));
            return new ProductLoadCompleteAction(response);
          }),
          catchError((error) => of(new ProductLoadFailAction(error))),
        );
      }),
    ),
  );

  /**
   *
   * @param {Store<OrderBuilderState>} store the usual in-memory store of application state.
   * @param {Actions} actions$ an Observable subclass which deals with actions
   *                           taken by or in the application
   * @param {ProductsOpenPlatformService} productsApi
   * @param {ProductService} productService
   */
  constructor(
    private store: Store<OrderBuilderState>,
    private actions$: Actions,
    private productsApi: ProductsOpenPlatformService,
    private productService: ProductService,
  ) {}
}
